var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReceipt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DBE1E6",
  d: "M13.333 14.667H2.667A.667.667 0 0 1 2 14.001V2a.667.667 0 0 1 .667-.667h10.666a.667.667 0 0 1 .667.667v12a.667.667 0 0 1-.667.666m-8-8.666v1.333h5.334V6.001zm0 2.666v1.334h5.334V8.667z"
})));
export { SvgReceipt as ReactComponent };
export default __webpack_public_path__ + "Receipt.1aa37c66.svg";